<template>
  <modal
    v-if="model"
    v-model="shown"
    title="Send Viewpoints Invitations"
    :footer="false"
    id="viewpoints-invite-dialofg"
  >
    <InviteControl :model="model" :show-examples="false"></InviteControl>
  </modal>
</template>

<script setup lang="ts">
import { Modal } from "uiv";
import { ref } from "vue";
import InviteControl from "./invite-control.vue";
import { InviteControlApiModel } from "../../api-models";

const resolveCallback = ref<(() => void) | null>(null);

const model = ref<InviteControlApiModel | null>(null);

const shown = ref(false);

function open(inviteModel: InviteControlApiModel): Promise<void> {
  model.value = inviteModel;
  shown.value = true;
  return new Promise((resolve) => {
    resolveCallback.value = resolve;
  });
}

function close(): void {
  shown.value = false;
  model.value = null;
  if (resolveCallback.value) {
    resolveCallback.value();
  }
}

defineExpose({ open, close });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"></style>
